import { comparisonData } from '@/mocks/homeData';

export default function ComparisonTable() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Why Use Basetao Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            See the difference an organized approach makes to your shopping workflow
          </p>
        </div>

        <div className="overflow-hidden rounded-lg border border-background-200">
          <table className="w-full">
            <thead>
              <tr>
                <th className="text-left px-5 py-4 bg-background-100 text-foreground-700 text-sm font-semibold w-1/3">
                  Aspect
                </th>
                <th className="text-left px-5 py-4 bg-background-200/60 text-foreground-600 text-sm font-semibold">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-close-circle-line text-foreground-400"></i>
                    Without Spreadsheet
                  </span>
                </th>
                <th className="text-left px-5 py-4 bg-primary-50/60 text-foreground-600 text-sm font-semibold">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-checkbox-circle-line text-primary-500"></i>
                    With Basetao Spreadsheet
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => (
                <tr key={row.aspect} className={index % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="px-5 py-3.5 text-sm font-medium text-foreground-800">
                    {row.aspect}
                  </td>
                  <td className="px-5 py-3.5 text-sm text-foreground-500">
                    {row.without}
                  </td>
                  <td className="px-5 py-3.5 text-sm text-primary-700 font-medium">
                    {row.with}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}